import Breadcrumbs from "@/components/Breadcrumbs";
import { CLINIC_NAME } from "@/lib/constants";

const PrivacyPolicy = () => (
  <div>
    <section className="bg-secondary py-12">
      <div className="container">
        <Breadcrumbs items={[{ label: "Privacy Policy" }]} />
        <h1 className="font-heading text-3xl font-bold text-secondary-foreground">Privacy Policy</h1>
      </div>
    </section>
    <section className="py-12 md:py-16">
      <div className="container max-w-3xl">
        <article className="prose prose-sm md:prose-base max-w-none prose-headings:font-heading prose-headings:text-secondary-foreground prose-h2:text-xl prose-h2:mt-8 prose-h2:mb-3 prose-h3:text-base prose-h3:mt-6 prose-h3:mb-2 prose-p:text-muted-foreground prose-p:leading-relaxed prose-li:text-muted-foreground prose-a:text-primary">
          <p className="text-sm text-muted-foreground italic">Last updated: January 2025</p>

          <p>
            Visitors to this website are bound by the following terms and conditions ("Terms") so please
            read these carefully before continuing to use this site. If you do not agree with any of these
            terms, please do not use this site.
          </p>

          <h2>Disclaimer of Warranties, Inaccuracies or Errors</h2>
          <ul>
            <li>
              Although {CLINIC_NAME} tries to ensure that all information and recommendations, whether in
              relation to the products, services, offerings or otherwise (hereinafter "Information") provided
              as part of this website is correct at the time of inclusion on the website, {CLINIC_NAME} makes
              no representations or warranties as to the completeness or accuracy of Information.
            </li>
            <li>
              Information is supplied upon the condition that the persons receiving the same will make their
              own determination as to its suitability for their purposes prior to use or in connection with
              the making of any decision. {CLINIC_NAME} or their employees or agents shall not be liable for
              any loss, damage or expense arising out of any access to, use of this website or the
              Information, or any website linked to this website.
            </li>
            <li>
              Nothing contained herein is to be construed as a recommendation to use any service, product,
              process, equipment or formulation, in conflict with any patent, or otherwise and {CLINIC_NAME}
              makes no representation or warranty, express or implied that, the use thereof will not infringe
              any patent, or otherwise.
            </li>
            <li>
              Dental records generated electronically are provided only for convenience. These may not be
              complete and are subject to updates. You are requested to kindly collect the signed copy of the
              case paper from {CLINIC_NAME}. Please note that these dental records are not a substitute for a
              dental advice / opinion.
            </li>
            <li>
              <strong>Changes in the Privacy Policy</strong> — We reserve the right to amend our privacy /
              security policy and make the new provisions effective for all information we maintain from time
              to time. The revised policy will be posted in our facilities and offices, and will be available
              while obtaining the treatment from our hospital directly. Your use of our website shall comprise
              of acceptance of any changes of this Privacy and Security Policy.
            </li>
          </ul>

          <h2>Availability</h2>
          <ul>
            <li>
              {CLINIC_NAME} controls and operates this website from India. If you use this website from
              outside of India, you are entirely responsible for compliance with all applicable local laws.
            </li>
            <li>
              This website may be linked on other websites on the World Wide Web that are not under the
              control of or maintained by {CLINIC_NAME}. Such links do not indicate any responsibility or
              endorsement on our part for the external website concerned, its contents or the links displayed
              on it. These links are provided only as a convenience, in order to help you find relevant
              websites, services and/or products that may be of interest to you, quickly and easily. It is
              your responsibility to decide whether any services and/or products available through any of
              these websites are suitable for your purposes. {CLINIC_NAME} is not responsible for the owners
              or operators of these websites or for any goods or services they supply or for the content of
              their websites and does not give or enter into any conditions, warranties or other terms or
              representations in relation to any of these or accept any liability in relation to any of these
              (including any liability arising out of any claim that the content of any external website to
              which this website includes a link infringes the intellectual property rights of any third
              party).
            </li>
          </ul>

          <h2>Applicable Law and Jurisdiction</h2>
          <ul>
            <li>
              These terms and conditions are governed by and to be interpreted in accordance with laws of
              India, without regard to the choice or conflicts of law provisions of any jurisdiction. You
              agree, in the event of any dispute arising in relation to these terms and conditions or any
              dispute arising in relation to the website whether in contract or tort or otherwise, to submit
              to the jurisdiction of the courts located at Mumbai, India for the resolution of all such
              disputes.
            </li>
          </ul>

          <h2>Information Shared</h2>
          <ul>
            <li>
              In order to better know the User of our Website, when you access the Services, we may ask you
              to voluntarily provide us with certain information that personally identifies you or could be
              used to personally identify you. Without prejudice to the generality of the above, information
              collected by us from you may include (but is not limited to) the following:
              <ol>
                <li>Contact data (such as your email address and phone number);</li>
                <li>Demographic data (such as your gender, your date of birth and your pin code);</li>
                <li>
                  Data regarding your usage of the services and history of the appointments and other
                  transactions made by or with you through the use of Services;
                </li>
                <li>
                  Health or medical & dental data (such as your past medical history and conditions,
                  diagnostic reports, prescriptions and medication history);
                </li>
                <li>Insurance data (such as your insurance carrier and insurance plan); and</li>
                <li>
                  Other information that you voluntarily choose to provide to us (such as your correspondence
                  address details, family details, work details, etc.)
                </li>
              </ol>
            </li>
            <li>
              {CLINIC_NAME} takes your right to privacy very seriously and other than as specifically stated
              in this Privacy Policy, will only disclose your personal information in the event it is required
              to do so by law, rule, regulation, law enforcement agency, governmental official, legal
              authority or similar requirements or when {CLINIC_NAME}, in its sole discretion, deems it
              necessary in order to protect its rights or the rights of others, to prevent harm to persons or
              property, to fight fraud and credit risk, or to enforce or apply the Terms of Use.
            </li>
          </ul>

          <h3>Cookies</h3>
          <p>
            Cookies is an alphanumeric identifier which we transfer to your hard drive through your web
            browser when you visit our website. It enables our own system to recognise you when you visit our
            website again and improve our service to you. Cookies may also be used to compile aggregate
            information about areas of our website that are visited most frequently. This traffic information
            can be used to enhance the content of our website and make your use of it easier. We do not track
            which pages you looked at while visiting the website. If you wish to reject our cookie, you can
            configure your browser to do so.
          </p>

          <h2>Terms & Conditions for Payment Service</h2>
          <ol>
            <li>
              The said information will not be utilized and shared by this website with any of the third
              parties unless required by law, regulation or court order.
            </li>
          </ol>

          <h2>Password and Security</h2>
          <ul>
            <li>
              You agree not to give or make available your password, OTP or other means to access your
              account to any unauthorized individuals. You are responsible for all payments you authorize
              using the services at the clinic website.
            </li>
            <li>
              If you permit other persons to use password or other means to access your account, you are
              responsible for any transaction they authorize.
            </li>
          </ul>
        </article>
      </div>
    </section>
  </div>
);

export default PrivacyPolicy;
